import { render, staticRenderFns } from "./assStatoGruppoStato.vue?vue&type=template&id=ddb2a62c&"
import script from "./assStatoGruppoStato.vue.ts?vue&type=script&lang=ts&"
export * from "./assStatoGruppoStato.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports